export const isJsonResponse = (response: Response): boolean => {
  const type = response.headers.get('content-type');
  return Boolean(type?.includes('application/json') || type?.includes('application/feed+json'));
};
